/** @import modules */

import { createContext } from "react";

/** @create context */

export const MontageContext = createContext ( null );